import { Navigate, type RouteObject } from 'react-router-dom';
import AssetsPage from '../pages/AssetsPage';
import ManufacturerPage from './pages/ManufacturerPage';

const routes: RouteObject[] = [
  {
    index: true,
    element: <AssetsPage tab="manufacturers" />,
  },
  {
    path: ':id',
    children: [
      {
        index: true,
        element: <Navigate to="details" replace />,
      },
      {
        path: ':tab',
        element: <ManufacturerPage />,
      },
    ],
  },
];

export default routes;
